import React from 'react';
import { Icon } from './Icon.js';
export const IconQueueFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("rect", { x: ".5", width: "11", height: "6", rx: "2.25", ry: "2.25", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m10.75,9H1.25c-.414,0-.75-.336-.75-.75s.336-.75.75-.75h9.5c.414,0,.75.336.75.75s-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("path", { d: "m10.75,12H1.25c-.414,0-.75-.336-.75-.75s.336-.75.75-.75h9.5c.414,0,.75.336.75.75s-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconQueueFill12.js.map